/**
 * The draw tool an SME armed from a toolbar draw button.
 *
 * With Equipment or Instrument armed, a drag on the drawing draws that kind at
 * once; with neither, the canvas holds the drawn box and asks for its kind with the
 * kind pill. Line arms path drawing: a click adds a vertex. Duct arms a line drawn as a
 * box: a drag opens the line form for a duct. A tool stays armed until
 * its asset is saved or canceled, until Escape with nothing in flight, or until its
 * own button is pressed again. The instrument tool is armed
 * through its draft, and a draft armed from its button re-arms after each save.
 */
export type ArmedTool = 'equipment' | 'instrument' | 'line' | 'duct';

/** The key that presses each draw tool's toolbar button at rest, as the button shows it. */
export const DRAW_TOOL_KEY: Record<ArmedTool, string> = {
  equipment: 'E',
  instrument: 'I',
  line: 'L',
  duct: 'D',
};

/** Each draw tool's label wherever a button arms or names it. Each starts with its tool's key. */
export const DRAW_TOOL_LABEL: Record<ArmedTool, string> = {
  equipment: 'Equipments',
  instrument: 'Instruments',
  line: 'Line',
  duct: 'Duct',
};
